module.exports = __webpack_public_path__ + "static/media/webhook.04a2d408.svg";